// Group GROUP 8. Comparison and Degree
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group8Data = {
  "id": "group_8",
  "title": {
    "tc": "比較與程度",
    "sc": "比较与程度",
    "en": "Comparison and Degree"
  },
  "subtitle": {
    "tc": "Comparison and Degree",
    "sc": "Comparison and Degree",
    "en": "Comparison and Degree"
  },
  "icon": "⚖️",
  "difficulty": "intermediate",
  "color": "from-purple-500 to-purple-600",
  "topics": [
    {
      "id": "comparative",
      "title": {
        "tc": "比較級",
        "sc": "比较级",
        "en": "Comparative"
      },
      "description": {
        "tc": "學習比較級的用法",
        "sc": "学习比较级的用法",
        "en": "Learn the usage of comparative forms"
      },
      "icon": "📈",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "comp_1",
          "sentence": "This room is bigger than that one.",
          "analysis": "This room (S) is (V) bigger (C) than (conj) that one (O-comp).",
          "translation": {
            "tc": "這個房間比那個大。",
            "sc": "这个房间比那个大。",
            "en": "This room is bigger than that one."
          }
        },
        {
          "id": "comp_2",
          "sentence": "She runs faster than I do.",
          "analysis": "She (S) runs (V) faster (M) than (conj) I (S) do (V-aux).",
          "translation": {
            "tc": "她跑得比我快。",
            "sc": "她跑得比我快。",
            "en": "She runs faster than I do."
          }
        },
        {
          "id": "comp_3",
          "sentence": "He is more patient than his peers.",
          "analysis": "He (S) is (V) more patient (C) than (conj) his peers (O-comp).",
          "translation": {
            "tc": "他比他的同齡人更有耐心。",
            "sc": "他比他的同龄人更有耐心。",
            "en": "He is more patient than his peers."
          }
        },
        {
          "id": "comp_4",
          "sentence": "Today is better than yesterday.",
          "analysis": "Today (S) is (V) better (C) than (conj) yesterday (O-comp).",
          "translation": {
            "tc": "今天比昨天好。",
            "sc": "今天比昨天好。",
            "en": "Today is better than yesterday."
          }
        },
        {
          "id": "comp_5",
          "sentence": "The new model costs less than the old one.",
          "analysis": "The new model (S) costs (V) less (M) than (conj) the old one (O-comp).",
          "translation": {
            "tc": "新模型比舊的便宜。",
            "sc": "新模型比旧的便宜。",
            "en": "The new model costs less than the old one."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：形容詞/副詞比較；注意 than 後的省略與代詞格。",
        "sc": "要点：形容词/副词比较；注意 than 后的省略与代词格。",
        "en": "Key points: adjective/adverb comparison; pay attention to ellipsis and pronoun case after than."
      }
    },
    {
      "id": "superlative",
      "title": {
        "tc": "最高級",
        "sc": "最高级",
        "en": "Superlative"
      },
      "description": {
        "tc": "學習最高級的用法",
        "sc": "学习最高级的用法",
        "en": "Learn the usage of superlative forms"
      },
      "icon": "🏆",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "super_1",
          "sentence": "He is the tallest student in the class.",
          "analysis": "He (S) is (V) the tallest (C) student (C) in the class (M).",
          "translation": {
            "tc": "他是班上最高的學生。",
            "sc": "他是班上最高的学生。",
            "en": "He is the tallest student in the class."
          }
        },
        {
          "id": "super_2",
          "sentence": "This is the most important point.",
          "analysis": "This (S) is (V) the most important (C) point (C).",
          "translation": {
            "tc": "這是最重要的一點。",
            "sc": "这是最重要的一点。",
            "en": "This is the most important point."
          }
        },
        {
          "id": "super_3",
          "sentence": "She runs the fastest on our team.",
          "analysis": "She (S) runs (V) the fastest (M) on our team (M).",
          "translation": {
            "tc": "她在我們隊裡跑得最快。",
            "sc": "她在我们队里跑得最快。",
            "en": "She runs the fastest on our team."
          }
        },
        {
          "id": "super_4",
          "sentence": "It was the least expensive option.",
          "analysis": "It (S) was (V) the least expensive (C) option (C).",
          "translation": {
            "tc": "這是最便宜的選擇。",
            "sc": "这是最便宜的选择。",
            "en": "It was the least expensive option."
          }
        },
        {
          "id": "super_5",
          "sentence": "That's the best movie I've seen.",
          "analysis": "That (S) is (V) the best (C) movie (C) <that> [I (S) have seen (V)].",
          "translation": {
            "tc": "那是我看過最好的電影。",
            "sc": "那是我看过最好的电影。",
            "en": "That's the best movie I've seen."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：the + 最上級；可接範圍/限制性關係子句。",
        "sc": "要点：the + 最高级；可接范围/限制性关系子句。",
        "en": "Key points: the + superlative; can be followed by scope/restrictive relative clauses."
      }
    }
  ]
};
